import { AxiosResponse } from 'axios';

import {
  ICreateSecretKeyRequest,
  ICreateSecretKeyResponse,
  IDeleteSecretKeyResponse,
  IGenerateTokenRequest,
  IGenerateTokenResponse,
  IGetSecretKeyResponse,
  IListSecretKeysResponse,
  ISecretKeySummary,
  IUpdateSecretKeyRequest,
  IUpdateSecretKeyResponse,
} from 'models/http/secret-keys';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { serverAxios } from 'utils/http';

class SecretKeysHttp {
  private static route = '/auth/secrets';
  private static clientLoginRoute = '/auth/client';

  public async list(abortController?: AbortController): Promise<ISecretKeySummary[]> {
    return serverAxios
      .get(SecretKeysHttp.route, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IListSecretKeysResponse>) => response.data.secrets);
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetSecretKeyResponse> {
    return serverAxios
      .get(`${SecretKeysHttp.route}/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSecretKeyResponse>) => response.data);
  }

  public async create(body: ICreateSecretKeyRequest): Promise<ICreateSecretKeyResponse> {
    return serverAxios
      .post(SecretKeysHttp.route, body, { timeout: HttpTimeoutPriority.Medium })
      .then((response: AxiosResponse<ICreateSecretKeyResponse>) => response.data);
  }

  public async update(id: number, body: IUpdateSecretKeyRequest): Promise<IUpdateSecretKeyResponse> {
    return serverAxios
      .patch(`${SecretKeysHttp.route}/${id}`, body, { timeout: HttpTimeoutPriority.Medium })
      .then((response: AxiosResponse<IUpdateSecretKeyResponse>) => response.data);
  }

  public async delete(id: number): Promise<IDeleteSecretKeyResponse> {
    return serverAxios
      .delete(`${SecretKeysHttp.route}/${id}`, { timeout: HttpTimeoutPriority.Medium })
      .then((response: AxiosResponse<IDeleteSecretKeyResponse>) => response.data);
  }

  public async generateToken(body: IGenerateTokenRequest): Promise<IGenerateTokenResponse> {
    return serverAxios
      .post(SecretKeysHttp.clientLoginRoute, body, { timeout: HttpTimeoutPriority.Medium })
      .then((response: AxiosResponse<IGenerateTokenResponse>) => response.data);
  }
}

export default SecretKeysHttp;
